/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * New password shown once — store it securely.
 * @export
 * @interface RotateApiAccountPassword200Response
 */
export interface RotateApiAccountPassword200Response {
    /**
     * Username for authentication (unchanged).
     */
    username: string;
    /**
     * New password — returned only once. Store it securely.
     */
    password: string;
}

/**
 * Check if a given object implements the RotateApiAccountPassword200Response interface.
 */
export function instanceOfRotateApiAccountPassword200Response(value: object): value is RotateApiAccountPassword200Response {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function RotateApiAccountPassword200ResponseFromJSON(json: any): RotateApiAccountPassword200Response {
    return RotateApiAccountPassword200ResponseFromJSONTyped(json, false);
}

export function RotateApiAccountPassword200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RotateApiAccountPassword200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function RotateApiAccountPassword200ResponseToJSON(json: any): RotateApiAccountPassword200Response {
    return RotateApiAccountPassword200ResponseToJSONTyped(json, false);
}

export function RotateApiAccountPassword200ResponseToJSONTyped(value?: RotateApiAccountPassword200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'password': value['password'],
    };
}

